// extracted by mini-css-extract-plugin
export default {"ruleInputContainer":"RuleInput_ruleInputContainer__QZy3X","inputContainer":"RuleInput_inputContainer__XdlRO","input":"RuleInput_input__q-1+8"};